module.exports = __webpack_public_path__ + "img/f6d051e82952f8f11256399349815411.svg";